import {action, computed, makeObservable, observable, runInAction} from 'mobx';

export class Parameter {
    id: string = '';
    value: any = '';
    oldValue: any = '';
    name?: string = undefined;
    setValue = (value: any) => {
        if (value !== null && value !== undefined) runInAction(() => (this.value = value));
    };

    constructor(id: string, defaultValue: any = '') {
        makeObservable(this, {
            id: observable,
            value: observable,
            oldValue: observable,
            name: observable,
        });
        this.id = id;
        this.value = defaultValue;
    }

    valueAsString = () => {
        return this.value?.toString();
    };
}
